import axios from "axios";

export default axios.create({
    baseURL: "https://be.maasta.in",
    withCredentials: true,
    crossDomain: true,
});